import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { TOOL_COLORS } from '../../constants/colors';
export const ColorPicker = ({ selectedColor, onColorChange, colors = TOOL_COLORS, ringColor }) => (_jsx("div", { className: "grid grid-cols-10 gap-2.5 px-1 justify-items-center", children: colors.map(({ color, name }) => {
        const defaultRing = color === '#FFFFFF' ? 'var(--dew)' : '#FFFFFF';
        const ring = ringColor
            ? (color.toUpperCase() === ringColor.toUpperCase() ? '#FFFFFF' : ringColor)
            : defaultRing;
        return (_jsx("button", { onClick: () => onColorChange(color), 
            // The button IS the colour dot. The selection ring is an
            // `outline` drawn outside the box — guaranteed centred (no
            // nested-element drift) and zero layout impact. outlineOffset
            // gives the visible "donut" gap between dot and ring; the
            // wider grid gap (gap-2.5) keeps the ring from crashing into
            // the next dot.
            className: "w-4 h-4 rounded-full transition-transform hover:scale-110", title: name, style: {
                backgroundColor: color,
                outline: selectedColor === color ? `2px solid ${ring}` : 'none',
                outlineOffset: 2,
                border: color === '#FFFFFF' || color === '#000000' ? '1px solid var(--pewter)' : 'none',
            } }, color));
    }) }));
